'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$7() {
  this.bG7 = null;
  this.bG5 = null;
  this.bG6 = false;
  this.bG3 = null;
  this.bG4 = false;
  this.bG8 = false;
  this.bG9 = false;
  this.bG7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$7 as $c_Lpresto_TwoFactorAuthView$$anon$7 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$7;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$7() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$7 as $h_Lpresto_TwoFactorAuthView$$anon$7 };
$h_Lpresto_TwoFactorAuthView$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bG7;
});
$p.t = (function() {
  if ((!this.bG6)) {
    this.bG5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bG6 = true;
  }
  return this.bG5;
});
$p.ad = (function() {
  if ((!this.bG4)) {
    this.bG3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bG4 = true;
  }
  return this.bG3;
});
$p.v = (function() {
  if ((!this.bG9)) {
    this.bG8 = false;
    this.bG9 = true;
  }
  return this.bG8;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$7, "presto.TwoFactorAuthView$$anon$7", ({
  Tw: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$7 as $d_Lpresto_TwoFactorAuthView$$anon$7 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$7.js.map
